import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  MorningConfigurationControl,
  MorningConfigurationFormValues,
} from '../../MorningConfigurationFormSchema';
import { AUTOMATICALLY_SYNC_INVOICES_OPTIONS, INVOICE_NUMBER_SYNC_STRATEGY_OPTIONS } from './constants';

type InvoicesConfigurationSectionProps = {
  defaultValues: MorningConfigurationFormValues;
  control: MorningConfigurationControl;
};

export const InvoicesConfigurationSection: FC<InvoicesConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Invoices" iconName="InvoiceListItem">
    <Controller
      name="syncApprovedInvoices"
      control={control}
      defaultValue={defaultValues.syncApprovedInvoices}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync your approved invoices"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_SYNC_INVOICES_OPTIONS}
        />
      )}
    />
    <Controller
      name="invoiceNumberSyncStrategy"
      control={control}
      defaultValue={defaultValues.invoiceNumberSyncStrategy}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how invoice numbers are managed"
          value={value}
          onChange={onChange}
          keyExtractor={(option) => option.value}
          options={INVOICE_NUMBER_SYNC_STRATEGY_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
